import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaAward, FaExternalLinkAlt } from "react-icons/fa";

const certifications = [
  {
    title: "Full Stack Development",
    issuer: "Apna College",
    year: "2024-2025",
    description: "Completed comprehensive training in Full Stack Development including HTML, CSS, JavaScript, React, Node.js, and MongoDB.",
    link: "https://www.linkedin.com/in/yash-koparkar-8307a128a/details/certifications/"
  },
  {
    title: "MERN Stack Development",
    issuer: "Bluestocks",
    year: "2026",
    description: "Software Development Engineer Intern at Bluestocks. Worked on real-world MERN stack projects and deployed scalable web applications.",
    link: "https://www.linkedin.com/in/yash-koparkar-8307a128a/details/experience/"
  },
  {
    title: "Problem Solving & DSA Badges on LeetCode",
    issuer: "LeetCode",
    year: "2022 - Present",
    description: "Solved 100+ problems across various difficulty levels. Strong foundation in data structures and algorithms.",
    link: "https://leetcode.com/u/yash_koparkar/"
  }
];

function Certifications() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Certifications</strong>
        </h1>
        <p style={{ color: "white", textAlign: "center", marginBottom: "40px" }}>
          Continuous learning and professional development
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {certifications.map((cert, index) => (
            <Col key={index} md={5} className="cert-card">
              <div className="cert-icon">
                <FaAward />
              </div>
              <div className="cert-content">
                <h3 className="cert-title">{cert.title}</h3>
                <h4 className="cert-issuer">{cert.issuer}</h4>
                <p className="cert-year">{cert.year}</p>
                <p className="cert-desc">{cert.description}</p>
                <a 
                  href={cert.link}
                  target="_blank" 
                  rel="noreferrer"
                  className="cert-link"
                >
                  View <FaExternalLinkAlt style={{ fontSize: "12px" }} /> →
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Certifications;